import { getTenantIDBasedOnURL } from 'global/tenant-config';

const removeBrikks = ['A13'];
const tenantId = getTenantIDBasedOnURL().toLowerCase();

export const validateBrikksByAgreements = (brikks, agreements) => ((tenantId.includes('vxb')) && agreements.length === 0
  ? brikks.filter(brikk => !removeBrikks.includes(brikk.id)) : brikks);
